"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = accountCreated;

var _noty = require("noty");

function accountCreated(profile) {
  (0, _noty.showNotificationText)("Welcome, ".concat(profile.fullName, "!"));
}